/*
 * Copyright © 2026 Bruce Matin,  ALL RIGHTS RESERVED!
 */

import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from '../theme';
import { ROUTES } from '../routes';

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const theme = useTheme();
  const pathnames = location.pathname.split('/').filter((x) => x);

  if (pathnames.length === 0) return null;

  return (
    <nav className="mb-4" aria-label="Breadcrumb">
      <ol className="flex list-none p-0">
        <li className="flex items-center">
          <Link to={ROUTES.HOME} style={{ color: theme.colors.primary }} className="hover:underline">Home</Link>
          <span className="mx-2" style={{ color: theme.colors.mutedText }}>&gt;</span>
        </li>
        {pathnames.map((value, index) => {
          const last = index === pathnames.length - 1;
          const to = `/${pathnames.slice(0, index + 1).join('/')}`;

          return (
            <li key={to} className="flex items-center">
              {last ? (
                <span style={{ color: theme.colors.text }}>{value.charAt(0).toUpperCase() + value.slice(1)}</span>
              ) : (
                <>
                  <Link to={to} style={{ color: theme.colors.primary }} className="hover:underline">
                    {value.charAt(0).toUpperCase() + value.slice(1)}
                  </Link>
                  <span className="mx-2" style={{ color: theme.colors.mutedText }}>&gt;</span>
                </>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
